import { Pipe, PipeTransform } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

import { AntragsType } from '../../types';

@Pipe({
  name: 'antragsTypeToI18n',
  standalone: true,
})
export class AntragsTypeToI18nPipe implements PipeTransform {
  public transform(antrag: { antragsArt: AntragsType }): string {
    switch (antrag.antragsArt) {
      case AntragsType.KURZANTRAG:
        return _('antrags_uebersicht.server.antrags_art.Kurzantrag');
      case AntragsType.LANGANTRAG_LEGACY:
      case AntragsType.LANGANTRAG:
        return _('antrags_uebersicht.server.antrags_art.Langantrag');
      default:
        return _('antrags_uebersicht.server.antrags_art.Langantrag');
    }
  }
}
